import { GS_KEEP_MINIFIED_SEARCH_OPEN } from '../constants';
let shouldKeepMinifiedSearchOpen = undefined;
export const devShouldKeepMinifiedOpen = () => {
  if (shouldKeepMinifiedSearchOpen !== undefined) {
    return shouldKeepMinifiedSearchOpen;
  } else {
    try {
      shouldKeepMinifiedSearchOpen = localStorage.getItem(GS_KEEP_MINIFIED_SEARCH_OPEN) === 'true';
      return shouldKeepMinifiedSearchOpen;
    } catch (_unused) {
      return false;
    }
  }
};